import React from 'react'
import routes from 'src/lib/rails-routes/rails-routes'
import { Button } from '@chatterbug/aaron'
import { usePageParams } from 'src/utils/params'
import { t } from 'src/lib/i18n-react'

import PageWrapupActions from 'src/ui/PageWrapup/subcomponents/PageWrapupActions/PageWrapupActions'

const ActivityWrapupActions = () => {
  const { l2Code } = usePageParams()

  return (
    <PageWrapupActions
      secondaryActionSection={
        <Button
          type="primaryAdvanced"
          fill="outline"
          href={routes.home_student({ code: l2Code })}
        >
          {t('Back to Home')}
        </Button>
      }
      primaryActionSection={
        <Button
          type="primaryAdvanced"
          href={routes.language_study({ code: l2Code })}
        >
          {t('Study More')}
        </Button>
      }
    />
  )
}

export default ActivityWrapupActions
